import { defineComponent as _defineComponent } from 'vue'
import BCXBreadcrumbs from '@/components/molecules/BCXBreadcrumbs.vue';
import useResponsiveness from '@/mixins/useResponsiveness';
import { computed } from 'vue';
import { useMyProjectsProvider } from '@/views/my-projects/composables/useMyProjects';
import MyProjectStatusLayer from '@/views/my-projects/components/offers/MyProjectStatusLayer.vue';
import MyProjectsIntro from '@/views/my-projects/components/MyProjectsIntro.vue';
import MyProjectsTabs from '@/views/my-projects/components/MyProjectsTabs.vue';
import useI18n from '@/mixins/useI18n';
import { useRoute } from 'vue2-helpers/vue-router';
import useUser from '@/mixins/useUser';
import useIsLeavingDirty from '@/utils/isLeavingDirty';


export default /*#__PURE__*/_defineComponent({
  __name: 'MyProjects',
  setup(__props) {

const { isMobileWidth } = useResponsiveness();

const { t } = useI18n();
const route = useRoute();
const { isGuest } = useUser('self');
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const { isLeavingDirty, onConfirm } = useIsLeavingDirty(); // Must be included here for it to work in MyProjectsInvoice.vue

const {
  isStatusLayerOpen,
} = useMyProjectsProvider({
  isNarrow: isMobileWidth
});

const breadcrumbs = computed(() => {
  const items: any = [
    {
      text: `${t('project-forum.labels.projects')}`,
      to: { path: '/projects' }
    },
    {
      text: `${t('my-projects.breadcrumbs.myprojects')}`,
      to: { path: '/my-projects' }
    },
    ...route.meta.breadcrumbNames.map((name: string) => ({
      text: `${t(`my-projects.breadcrumbs.${name}`)}`,
      to: { path: `/my-projects/${name}` }
    }))
  ];

  if (isMobileWidth.value) {
    items.splice(0, 1);
  }

  return items;
});


return { __sfc: true,isMobileWidth, t, route, isGuest, isLeavingDirty, onConfirm, isStatusLayerOpen, breadcrumbs, BCXBreadcrumbs, MyProjectStatusLayer, MyProjectsIntro, MyProjectsTabs }
}

})